import { render } from "./WizardDrivers.vue?vue&type=template&id=4b588982"
import script from "./WizardDrivers.vue?vue&type=script&lang=js"
export * from "./WizardDrivers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__